import { el, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import leftAlignmentToggleIconString from 'assets/images/left-alignment-toggle-icon.svg?raw';

import centerAlignmentToggleIconString from 'assets/images/center-alignment-toggle-icon.svg?raw';

import rightAlignmentToggleIconString from 'assets/images/right-alignment-toggle-icon.svg?raw';

const leftAlignmentToggleIcon = stringToSVG(leftAlignmentToggleIconString);
const centerAlignmentToggleIcon = stringToSVG(centerAlignmentToggleIconString);
const rightAlignmentToggleIcon = stringToSVG(rightAlignmentToggleIconString);

const alignmentTypes = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

class AlignmentControls {

  constructor(configuration) {

    this.alignment = configuration.alignment;
    this.onChange = configuration.onChange;
    this.hideTimeout = null;

    this.list = el('.alignment-controls', {}, [
      this.renderLeftAlignmentControl(),
      this.renderCenterAlignmentControl(),
      this.renderRightAlignmentControl()
    ]);

    this.button = this.renderButton();

    this.el = el('.alignment-controls-main', {
      onmouseenter: this.handleMouseEnter.bind(this),
      onmouseleave: this.handleMouseLeave.bind(this)
    }, [
      this.button
    ]);

  }

  handleMouseEnter() {

    if (this.hideTimeout !== null) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    mount(this.el, this.list);

    const element = this.list;
    const anchorElement = this.button;
    const viewportElement = void 0;
    const verticalOffset = 7;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = ['top', 'button'];

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  handleMouseLeave() {

    this.hideTimeout = setTimeout(function delayedHide() {
      unmount(this.el, this.list);
      this.hideTimeout = null;
    }.bind(this), 350);

  }

  renderButton() {

    const options = {};

    if (typeof this.alignment === 'string') {
      options.class = 'active';
    }

    const button = el('button.media-alignment-control', options, [
      centerAlignmentToggleIcon.cloneNode(true)
    ]);

    return button;

  }

  renderLeftAlignmentControl() {

    this.leftAlignmentControl = el('button', {
      class: 'media-alignment-control inline-toolbar-button',
      onclick: this.handleLeftAlignmentControlClick.bind(this)
    }, leftAlignmentToggleIcon.cloneNode(true));

    return el('x-tooltip', {
      text: 'Ailgn left'
    }, this.leftAlignmentControl);

  }

  renderCenterAlignmentControl() {

    this.centerAlignmentControl = el('button', {
      class: 'media-alignment-control inline-toolbar-button',
      onclick: this.handleCenterAlignmentControlClick.bind(this)
    }, centerAlignmentToggleIcon.cloneNode(true));

    return el('x-tooltip', {
      text: 'Ailgn center'
    }, this.centerAlignmentControl);

  }

  renderRightAlignmentControl() {

    this.rightAlignmentControl = el('button', {
      class: 'media-alignment-control inline-toolbar-button',
      onclick: this.handleRightAlignmentControlClick.bind(this)
    }, rightAlignmentToggleIcon.cloneNode(true));

    return el('x-tooltip', {
      text: 'Ailgn right'
    }, this.rightAlignmentControl);

  }

  resetAll() {

    const controls = [
      this.leftAlignmentControl,
      this.centerAlignmentControl,
      this.rightAlignmentControl
    ];

    for (let control of controls) {

      control.classList.remove('active');

    }

  }

  applyState() {

    this.resetAll();

    this.active.classList.add('active');

    this.button.classList.remove('active');
    this.button.classList.add('active');

  }

  handleLeftAlignmentControlClick() {

    if (this.alignment === alignmentTypes.LEFT) {
      return;
    }

    this.alignment = alignmentTypes.LEFT;
    this.active = this.leftAlignmentControl;

    this.applyState();

    this.onChange({
      marginLeft: null,
      marginRight: 'auto'
    });

  }

  handleCenterAlignmentControlClick() {

    if (this.alignment === alignmentTypes.CENTER) {
      return;
    }

    this.alignment = alignmentTypes.CENTER;
    this.active = this.centerAlignmentControl;

    this.applyState();

    this.onChange({
      marginLeft: 'auto',
      marginRight: 'auto'
    });

  }

  handleRightAlignmentControlClick() {

    if (this.alignment === alignmentTypes.RIGHT) {
      return;
    }

    this.alignment = alignmentTypes.RIGHT;
    this.active = this.rightAlignmentControl;

    this.applyState();

    this.onChange({
      marginLeft: 'auto',
      marginRight: null
    });

  }

  getActiveControl() {

    if (this.alignment === alignmentTypes.LEFT) {
      return this.leftAlignmentControl;
    } else if (this.alignment === alignmentTypes.CENTER) {
      return this.centerAlignmentControl;
    } else {
      return this.rightAlignmentControl;
    }

  }

  update(configuration) {

    this.alignment = configuration.alignment;

    this.active = this.getActiveControl();

    this.applyState();

  }

}

AlignmentControls.determineAlignment = function determineAlignment(element) {

  const marginLeft = element.marginLeft;
  const marginRight = element.marginRight;

  if (marginLeft === void 0 && marginRight === void 0) {
    return alignmentTypes.CENTER;
  }

  if (marginLeft === 'auto' && marginRight === 'auto') {
    return alignmentTypes.CENTER;
  }

  if (marginLeft === 'auto') {
    return alignmentTypes.RIGHT;
  }

  return alignmentTypes.LEFT;

};

export default AlignmentControls;